"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StatusTag_1 = require("./StatusTag");
exports.default = StatusTag_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/StatusTag/index.js
// module id = 1817
// module chunks = 8